import React from 'react'
import { useIntl } from 'react-intl'
import Caption from '../Typography/Caption'
import config from 'constants/config'
import FormatDecimal from 'components/utils/Formatters/FormatDecimal'
import { getPlural } from 'lib/string/pluralize'

interface Props {
  value: number
  /**
   * @default neutral-two
   */
  colour?: 'neutral-two' | 'neutral-three'
}

function PriceRowPointsSale(props: Props) {
  const { value, colour = 'neutral-two' } = props
  const intl = useIntl()
  const wasPointsLabel = intl.formatMessage(
    {
      id: '_HAS4DfBTrR8pJ3VsQJl',
      defaultMessage: 'Was {points}{unit}',
      description: 'Strikethrough points sale label showing previous points amount',
    },
    {
      points: <FormatDecimal value={value} />,
      unit: getPlural(config.loyalty.pointsUnitAbbreviation),
    },
  )

  return <Caption
    as="s"
    variant="medium"
    colour={colour}
  >
    {wasPointsLabel}
  </Caption>
}

export default PriceRowPointsSale
